import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { MailIcon } from 'lucide-react';
const steps = [{
  title: 'Open KittyPot and sign in.'
}, {
  title: 'Go to Settings → Delete account.'
}, {
  title: 'Confirm.',
  detail: 'We remove or anonymise your profile, sign-in details, saved bank details, and push tokens. Shared kitty history may keep a “Deleted user” label so other people’s balances still add up.'
}];
export function DeleteAccount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-483" data-mp="2he8zlkrsh4b5">
      <SEO title="Delete your KittyPot account | KittyPot" description="How to permanently delete your KittyPot account from the app, and what happens to your data when you do." ogTitle="Delete your KittyPot account" ogDescription="How to permanently delete your KittyPot account and what happens to your data." path="/delete-account" data-id="element-484" data-mp="2cctbfjubehoj" />
      <Navbar data-id="element-485" data-mp="lqrab8u3bpk1" />
      <main className="pt-36 pb-24" data-id="element-486" data-mp="lr0ycqvkrmn3">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-487" data-mp="qo15z682oxgb">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-488" data-mp="qm6mzxgd3fev">
            <h1 className="text-4xl md:text-5xl font-black text-kitty-dark mb-5 tracking-tight" data-id="element-489" data-mp="1ie5oezc9vaew">
              Delete your KittyPot account
            </h1>
            <p className="text-lg text-gray-500 mb-12 max-w-xl" data-id="element-490" data-mp="19esg49zvwrvr">
              You can permanently delete your KittyPot account from the app:
            </p>
          </motion.div>

          <motion.ol initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="space-y-4 mb-12" data-id="element-491" data-mp="3p89gzcy4mqiv">
            {steps.map((step, index) => <li key={step.title} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-7 flex gap-5" data-id="element-492" data-mp="362l404tvaemk" data-mpi={index}>
                <span className="flex-shrink-0 w-9 h-9 rounded-full bg-kitty-yellow text-kitty-dark font-bold flex items-center justify-center" data-id="element-493" data-mp="2wc0agvt1w0ai">
                  {index + 1}
                </span>
                <div data-id="element-494" data-mp="2mcsxi9q8a7nx">
                  <p className="text-lg font-bold text-kitty-dark leading-snug" data-id="element-495" data-mp="2mc9bagtjox43">
                    {step.title}
                  </p>
                  {step.detail && <p className="text-gray-500 leading-relaxed mt-2" data-id="element-496" data-mp="2dd5sldyaijq4">
                      {step.detail}
                    </p>}
                </div>
              </li>)}
          </motion.ol>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gray-950 rounded-2xl p-8 md:p-10 text-white" data-id="element-497" data-mp="bmas48t51wd2">
            <div className="w-11 h-11 rounded-2xl bg-white/[0.08] flex items-center justify-center mb-5" data-id="element-498" data-mp="o1iobl7br50f">
              <MailIcon className="w-5 h-5 text-kitty-yellow" aria-hidden="true" data-id="element-499" data-mp="xtoo3h3tiqq6" />
            </div>
            <h2 className="text-xl font-bold mb-3" data-id="element-500" data-mp="77twkqdst8n">Cannot open the app?</h2>
            <p className="text-gray-400 leading-relaxed" data-id="element-501" data-mp="54hixz9uz2vy">
              Email{' '}
              <a href="mailto:support@kittypot.com" className="font-semibold text-kitty-yellow underline underline-offset-2 transition-colors hover:text-kitty-yellow-500" data-id="element-502" data-mp="a4c5jqmlp6b7">
                support@kittypot.com
              </a>{' '}
              from the email on your KittyPot account and ask us to delete it.
              We will check it is you first.
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-sm text-gray-500 mt-8" data-id="element-503" data-mp="1o4gpyn8q2l30">
            For more on how we handle your data, read our{' '}
            <a href="https://www.kittypot.com/privacy-policy/" className="font-semibold text-kitty-dark underline underline-offset-2 transition-colors hover:text-kitty-yellow-700" data-id="element-504" data-mp="1t2iirzvy9yro">
              Privacy Policy
            </a>
            .
          </motion.p>
        </div>
      </main>
      <Footer data-id="element-505" data-mp="2grtcixevuswb" />
    </div>;
}